<template>
<div v-if="saibyouga">
<v-container fluid class="mb-5">
    <v-row justify="space-between">
        <v-col cols="1" class="text-left mr-4">
            <v-btn @click="cancel()" color="" class="mr-5">
            キャンセル</v-btn>
        </v-col>

        <v-col cols="4" class="text-left">
            <v-btn @click="update_settings()" color="mygreen" class="white--text mr-5">更新</v-btn>
        </v-col>
        <v-spacer></v-spacer>
    </v-row>
</v-container>

<v-container fluid class="main_wrap mb-7">
    <h3 class="text-left mb-5">基本営業時間設定</h3>
    <v-row>
        <v-col cols="8" style="padding-left:60px">
            <v-row>
                <v-col cols="2"></v-col>
                <v-col cols="1"></v-col>
                <v-col cols="4" class="text-center" style="padding-left:22px;">午前</v-col>
                <v-col cols="1"></v-col>
                <v-col cols="4" class="text-center" style="padding-left:28px;">午後</v-col>
            </v-row>
        </v-col>
    </v-row>

    <v-row v-for="(v,index) in eigyoubi" :key="v.id" justify="start">
        <v-col cols="8" style="padding-left:60px; padding-right:0px; padding-bottom:0px;">
        <v-row>
            <v-col cols="2" class="text-left myrow">
                {{v.dayofweek}}曜日
            </v-col>
            <v-col cols="1" class="text-left myrow">
                <v-checkbox class="mycheck d-flex"
                color="rgba(0, 189, 242, 1)"
                  v-model="v.first_check"
                  @change="change_check(index, 'first_check', v.first_check)"
                ></v-checkbox>
            </v-col>
            <v-col cols="4" class="text-left d-flex flex-nowrap myrow mytime">

                        <v-select dense
                            append-icon="mdi-clock-time-four-outline"
                            menu-props="auto"
                            :items="first_start"
                            v-model="v.first_start"
                            outlined
                            placeholder="選択してください"
                            :disabled="!!!v.first_check"
                            :filled="!!!v.first_check"
                            @change="change_shift(index, 'first_end', v.first_start)"
                        ></v-select>


                    <span style="line-height: 2.4em; margin: 0 8px;">～</span>

                        <v-select dense
                            append-icon="mdi-clock-time-four-outline"
                            menu-props="auto"
                            :items="first_end"
                            v-model="v.first_end"
                            outlined
                            placeholder="選択してください"
                            :disabled="!!!v.first_check"
                            :filled="!!!v.first_check"
                            @change="change_shift(index, 'first_start', v.first_end)"
                        ></v-select>


            </v-col>
            <v-col cols="1" class="text-left myrow">
                <v-checkbox class="mycheck d-flex"
                color="rgba(0, 189, 242, 1)"
                  v-model="v.second_check"
                  @change="change_check(index, 'second_check', v.second_check)"
                ></v-checkbox>
            </v-col>
            <v-col cols="4" class="text-left d-flex flex-nowrap myrow mytime">

                        <v-select dense
                            append-icon="mdi-clock-time-four-outline"
                            menu-props="auto"
                            :items="second_start"
                            v-model="v.second_start"
                            outlined
                            placeholder="選択してください"
                            :disabled="!!!v.second_check"
                            :filled="!!!v.second_check"
                            @change="change_shift(index, 'second_end', v.second_start)"
                        ></v-select>

                    <span style="line-height: 2.4em; margin: 0 8px;">～</span>

                        <v-select dense
                            append-icon="mdi-clock-time-four-outline"
                            menu-props="auto"
                            :items="second_end"
                            v-model="v.second_end"
                            outlined
                            placeholder="選択してください"
                            :disabled="!!!v.second_check"
                            :filled="!!!v.second_check"
                            @change="change_shift(index, 'second_start', v.second_end)"
                        ></v-select>

            </v-col>
        </v-row>
        </v-col>
        <v-col cols="4">
        </v-col>
    </v-row>
</v-container>

<v-container fluid class="main_wrap mb-7">
    <h3 class="text-left mb-9">UNIT担当設定</h3>
    <v-row>
    <v-col cols="8" style="padding-left:60px; padding-right:0px;">
    <v-row justify="space-between">
        <v-col cols="2" class="text-left" style="max-height:80px;margin:auto;">
            UNIT1
        </v-col>
        <v-col cols="1"></v-col>
        <v-col cols="4" class="text-left" style="max-height:80px;">
            <v-select
                v-model="unit.unit1"
                :items="dic_doctor"
                item-text="doctor"
                item-value="id"
                outlined
                placeholder="選択してください"
            ></v-select>
        </v-col>
        <v-col cols="5"></v-col>

        <v-col cols="2" class="text-left" style="max-height:80px;margin:auto;">
            UNIT2
        </v-col>
        <v-col cols="1"></v-col>
        <v-col cols="4" class="text-left" style="max-height:80px;">
            <v-select
                v-model="unit.unit2"
                :items="dic_doctor"
                item-text="doctor"
                item-value="id"
                outlined
                placeholder="選択してください"
            ></v-select>
        </v-col>
        <v-col cols="5"></v-col>
        <v-col cols="2" class="text-left" style="max-height:80px;margin:auto;">
            UNIT3
        </v-col>
        <v-col cols="1"></v-col>
        <v-col cols="4" class="text-left" style="max-height:80px;">
            <v-select
                v-model="unit.unit3"
                :items="dic_doctor"
                item-text="doctor"
                item-value="id"
                outlined
                placeholder="選択してください"
            ></v-select>
        </v-col>
        <v-col cols="5"></v-col>
        <v-col cols="2" class="text-left" style="max-height:80px;margin:auto;">
            UNIT4
        </v-col>
        <v-col cols="1"></v-col>
        <v-col cols="4" class="text-left" style="max-height:80px;">
            <v-select
                v-model="unit.unit4"
                :items="dic_doctor"
                item-text="doctor"
                item-value="id"
                outlined
                placeholder="選択してください"
            ></v-select>
        </v-col>
        <v-col cols="5"></v-col>
        <v-col cols="2" class="text-left" style="max-height:80px;margin:auto;">
            UNIT5
        </v-col>
        <v-col cols="1"></v-col>
        <v-col cols="4" class="text-left" style="max-height:80px;">
            <v-select
                v-model="unit.unit5"
                :items="dic_doctor"
                item-text="doctor"
                item-value="id"
                outlined
                placeholder="選択してください"
            ></v-select>
        </v-col>
        <v-col cols="5"></v-col>
    </v-row>
    </v-col>
    </v-row>
</v-container>

<!--
<v-container fluid class="main_wrap mb-7">
    <h3 class="text-left mb-9">有給休暇の共通設定</h3>
    <v-row class="text-left text-bold mb-2">付与数</v-row>
    <v-row class="text-left">
        <v-col cols="2">週の契約<br>労働日数</v-col>
        <v-col cols="2">最小労働<br>日数</v-col>
        <v-col cols="1"></v-col>
        <v-col cols="1"></v-col>
        <v-col cols="1"></v-col>
        <v-col cols="1"></v-col>
        <v-col cols="1"></v-col>
        <v-col cols="1"></v-col>
        <v-col cols="1"></v-col>
    </v-row>
    <v-row class="text-left">
        <v-col cols="2"></v-col>
        <v-col cols="2"></v-col>
        <v-col cols="1">0.5</v-col>
        <v-col cols="1">1.5</v-col>
        <v-col cols="1">2.5</v-col>
        <v-col cols="1">3.5</v-col>
        <v-col cols="1">4.5</v-col>
        <v-col cols="1">5.5</v-col>
        <v-col cols="1">6.5以上</v-col>
    </v-row>
    <v-row class="text-left text-bold mt-1 mb-1"><v-divider></v-divider></v-row>


    <v-row v-for="v in yuukyuu" class="text-left" :key="v.id">
        <v-col cols="2">{{v.id}}日以上</v-col>
        <v-col cols="2"> <v-text-field data-yuukyuu="min" v-model="v.min" outlined></v-text-field> </v-col>
        <v-col cols="1"> <v-text-field data-yuukyuu="fuyo1" v-model="v.fuyo1" outlined></v-text-field> </v-col>
        <v-col cols="1"> <v-text-field data-yuukyuu="fuyo2" v-model="v.fuyo2" outlined></v-text-field> </v-col>
        <v-col cols="1"> <v-text-field data-yuukyuu="fuyo3" v-model="v.fuyo3" outlined></v-text-field> </v-col>
        <v-col cols="1"> <v-text-field data-yuukyuu="fuyo4" v-model="v.fuyo4" outlined></v-text-field> </v-col>
        <v-col cols="1"> <v-text-field data-yuukyuu="fuyo5" v-model="v.fuyo5" outlined></v-text-field> </v-col>
        <v-col cols="1"> <v-text-field data-yuukyuu="fuyo6" v-model="v.fuyo6" outlined></v-text-field> </v-col>
        <v-col cols="1"> <v-text-field data-yuukyuu="fuyo7" v-model="v.fuyo7" outlined></v-text-field> </v-col>
    </v-row>





    <v-row class="text-left text-bold mb-2">有給失効設定</v-row>
    <v-row class="text-left">
        <v-col cols="2">付与後</v-col>
        <v-col cols="2">
            <v-text-field v-model="shikkou" outlined></v-text-field>
        </v-col>
        <v-col cols="1">ヶ月</v-col>
        <v-spacer></v-spacer>
    </v-row>
</v-container>
-->



<v-container fluid class="main_wrap mb-7">
    <h3 class="text-left mb-5">ボイス再生設定</h3>
    <v-row>
        <v-col cols="8" style="padding-left:60px">
            <v-checkbox class="mycheck d-flex"
            color="rgba(0, 189, 242, 1)"
              v-model="yoyaku"
              label="予約時"
            ></v-checkbox>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="8" style="padding-left:60px">
            <v-checkbox class="mycheck d-flex"
            color="rgba(0, 189, 242, 1)"
              v-model="raiin"
              label="来院時"
            ></v-checkbox>
        </v-col>
    </v-row>


</v-container>



<template>
  <div class="text-center">
    <v-snackbar
      v-model="snackbar"
      timeout="3000"
      vertical
      top
      right
      outlined
    >
      <div v-html="snackbar_text"></div>
      <template v-slot:action="{  }">
        <img @click="snackbar = false" class="img" src="/img/x.svg" style="cursor:pointer;" />
      </template>
    </v-snackbar>
  </div>
</template>



</div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import myMixin from '@/mixin.js';
import {mapGetters} from 'vuex';
/* eslint-disable */


export default {
    mixins: [myMixin],
    components:{
    },


// datas
data(){
    return {
        // voice settings
        yoyaku: 1,
        raiin: 0,

        yuukyuu:[],
        shikkou: 24,

      saibyouga: true,
      snackbar: false,
      snackbar_text: '更新しました',



        first_start: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
        first_end: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
        second_start: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
        second_end: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],


        dic_doctor: [],
        unit: {
            unit1: null,
            unit2: null,
            unit3: null,
            unit4: null,
            unit5: null,
        },
        unit_org:[],

        eigyoubi: []
    }
},  // datas


computed: {
    ...mapGetters(['user', 'user_name', 'is_admin']),

},

watch: {

},

created () {
    console.log('%ccreated: SettingsView.vue', mycolor.purple);


    this.getEigyoubi();
    this.getYuukyuu();
    this.getDoctors();
    this.getUnit();
    this.getSpeech();
},
mounted () {
  console.log('mounted');
},

methods: {
    // 営業日のチェック
    change_check(i, column, v){
        console.log('change_check()');
        let def_youbi = ['月','火','水','木','金','土','日'];
        console.log('index: ', i, def_youbi[i]);
        console.log('column: ', column);
        console.log('v: ', v);

            if(v==false){
                if(column==='first_check'){
                    this.eigyoubi[i]['first_start'] = '';
                    this.eigyoubi[i]['first_end'] = '';
                }else{
                    this.eigyoubi[i]['second_start'] = '';
                    this.eigyoubi[i]['second_end'] = '';
                }
            }else{
                if(column==='first_check'){
                    this.eigyoubi[i]['first_start'] = '09:00';
                    this.eigyoubi[i]['first_end'] = '13:00';
                }else{
                    this.eigyoubi[i]['second_start'] = '15:00';
                    this.eigyoubi[i]['second_end'] = '19:00';
                }
            }
    },

      change_shift(i, column, v){
        console.log('change_shift()');
        let def_youbi = ['月','火','水','木','金','土','日'];
        console.log('index: ', i, def_youbi[i]);
        console.log('column: ', column);
        console.log('v: ', v);

        // 時刻の片方が空だったらペアも空にする.
        if(v===''){
            this.eigyoubi[i][column] = '';
        }
      },


    // 有給設定を取得
    getYuukyuu(){
        console.log('getYuukyuu()');
        axios.get('/get_settings_yuukyuu')
        .then( (res) => {

            console.group();
            console.log('%c /get_settings_yuukyuu', mycolor.api);
            console.log('有給設定取得');
            console.log(res.data);
            console.groupEnd();
            this.yuukyuu = res.data;
        })
        .catch( () => {
          console.error();
        });


        axios.get('/get_settings_shikkou')
        .then( (res) => {
            console.group();
            console.log('%c /get_settings_shikkou', mycolor.api);
            console.log('有給失効取得');
            console.log(res.data.data);
            console.groupEnd();

            this.shikkou = res.data.data.yuukyuu_shikkou;
        })
        .catch( () => {
          console.error();
        });

    },

    // ボイス再生設定を取得
    getSpeech(){
        console.log('getSpeech()');
        axios.get('/get_speech')
        .then( (res) => {

            console.group();
            console.log('%c /get_speech', mycolor.api);
            console.log('ボイス再生設定');
            console.log(res.data);
            console.groupEnd();

            this.yoyaku = res.data.yoyaku;
            this.raiin = res.data.raiin;
        })
        .catch( () => { console.error(); });
    },

    // 営業日を取得
    getEigyoubi(){
        console.log('getEigyoubi()');
        axios.get('/get_eigyoubi')
        .then((res) => {
            console.group();
            console.log('%c /get_eigyoubi', mycolor.api);
            console.log('基本営業時間取得');
            console.log(res.data);
            console.groupEnd();

            this.eigyoubi = res.data;
        })
        .catch( () => { console.error(); });
    },


    // UNIT担当設定を取得
    getUnit(){
        axios.get('/get_unit')
        .then((res) => {
            console.group();
            console.log('%c /get_unit', mycolor.api);
            console.log('UNIT担当設定取得');
            console.log(res.data);
            console.groupEnd();

            for(let i=0; i<res.data.length; i++){
                this.unit['unit'+(i+1)] = res.data[i].staff_id;
            }



            let data = []
            function sortObjectByKeys(o) {
                return Object.keys(o).sort().reduce((r, k) => (r[k] = o[k], r), {});
            }
            var sorted=sortObjectByKeys(this.unit);
            console.log('sorted', sorted);
            for( const k in sorted ){
                data.push(this.unit[k]);
            }
            console.log(data);
            this.unit_org = data;  // 比較に使用する.


        })
        .catch(() => {
          console.error();
        });
    },


    // 担当医の辞書を取得
    getDoctors(){
        console.log('getDoctors()');
        axios.get('/get_tantoui')
        .then((res) => {

            console.group();
            console.log('%c /get_tantoui', mycolor.api);
            console.log('担当医の辞書取得');
            console.log(res.data);
            console.groupEnd();

            this.dic_doctor = res.data;
            this.dic_doctor.unshift({id: 0, doctor: '選択してください'});
            console.log(res.data);

        })
        .catch(() => {
          console.error();
        });
    },


    cancel(){
        console.log('cancel()');
          this.getEigyoubi();
          this.getDoctors();
          this.getUnit();
          this.saibyouga = false;
          this.$nextTick( () => (this.saibyouga = true) );
          console.log('再描画完了');
    },

    update_settings_yuukyuu(){

        console.group();
        console.log('%c %s', mycolor.strong, 'update_settings_yuukyuu');
        console.groupEnd();

        // DOMからdata-属性で取得 これはNodeListと呼ばれるもので、map()を持っていないのでArray化する
        let arr_yuukyuu = document.querySelectorAll('[data-yuukyuu]');
        arr_yuukyuu = Array.from(arr_yuukyuu);
        arr_yuukyuu = arr_yuukyuu.map( v => {
            return v.value;
        });
        console.log(arr_yuukyuu);

        // Promise.all() で書く
        axios.post('/update_settings_yuukyuu', arr_yuukyuu)
          .then( (res) => {
                console.log(res.data);

          })
          .catch()


        axios.post('/update_settings_shikkou', this.shikkou)
          .then( (res) => {
                console.log(res.data);
          })
          .catch()
    },

    async update_eigyoubi(){

        // 基本営業時間の更新
        console.group();
        console.log('%c %s', mycolor.strong, 'update_eigyoubi()');
        console.log('eigyoubi: ', this.eigyoubi);
        console.groupEnd();

        // axiosが入れ子になってるので,バリデーションをシンプルにしたい
        let res = await axios.post('/validate_time', this.eigyoubi);
        console.log('待つよ');


        if(res.data===true){

            axios.post('/update_eigyoubi', this.eigyoubi)
            .then( (res) => {
                  console.group();
                  console.log('%c /update_eigyoubi', mycolor.api);
                  console.log('基本営業時間更新');
                  console.log(res.data);
                  console.groupEnd();
            })
            .catch()

        }else{
            alert(res.data);
            return false;
        }


        return false;
    },

    update_unit(){

        // UNIT担当の更新
        let data = []
        function sortObjectByKeys(o) {
            return Object.keys(o).sort().reduce((r, k) => (r[k] = o[k], r), {});
        }
        var sorted=sortObjectByKeys(this.unit);
        console.log('sorted', sorted);
        for( const k in sorted ){
            console.log(k);
            console.log(this.unit[k]);
            data.push(this.unit[k]);
        }

        console.log(data);
        console.log(this.unit_org);
        var diff = [];

        for(let i=0; i<data.length; i++){
            console.log(data[i]);
            if( data[i]!==this.unit_org[i] ){
                diff.push(i+1);
            }
        }
        console.log('diff: ', diff);
        console.log('diff.length: ', diff.length);


        if( diff.length>0 ){
            let diff_text = '';
            for(let i=0; i<diff.length; i++){
                diff_text += 'UNIT: ' + diff[i] +"\n";
            }
            let yes = confirm("下記UNITの個別設定がクリアされます.　よろしいですか?\n\n"+diff_text)
            if(yes){
                ;
            }else{
                return false;
            }
        }

        console.group();
        console.log('%c %s', mycolor.strong, 'update_unit()');
        console.log(data);
        console.groupEnd();

        axios.post('/update_unit', data)
        .then((res) => {
              console.log('------------------------------');
              console.log(`%c${api}`, mycolor.orange);
              console.log(`%c${data}`, mycolor.strong);
              console.log(res.data);
        })
        .catch(() => {
          // eslint-disable-next-line
          console.error();
        });


    },  // update_unit()


    update_settings_speech(){
        let post_data = {};
        post_data['yoyaku'] = this.yoyaku;
        post_data['raiin'] = this.raiin;
        axios.post('update_settings_speech', post_data)
        .then((res) => {
            console.log('%c /update_settings_speech', mycolor.api);
            console.log(res.data);
        })
        .catch( () => { console.error(); });

    },  // update_settings_speech()


    update_settings(){

        // unit更新
        this.update_unit();

        // 基本営業日更新
        this.update_eigyoubi();

        // 有休設定更新
        this.update_settings_yuukyuu();

        // ボイス再生設定を更新
        this.update_settings_speech();

        // todo: 本当は更新全部終わったら
        this.snackbar = true;
        this.snackbar_text = `設定を更新しました`;
    }


}  // methods
}  // export
</script>


<style scoped>
.main_wrap{
    background: #fff;
    padding: 28px 30px;
}
/deep/ .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset{
    min-height: unset !important;
}
/deep/ .mycheck{
    margin-top: 0px !important;
    padding-top: 8px !important;
    padding-left: 16px;
}
/deep/ .v-input__slot{
    min-height: unset !important;
}
/deep/ .v-btn:not(.v-btn--round).v-size--default{
    min-width: 80px;
}
/deep/ .v-input__slot {
    min-height: 40px !important;
}
/deep/ .row + .row{
    margin-top: 0px;
}
/deep/ .myrow{
    max-height: 86px;
    margin: auto;
}
/deep/ .mytime{
    padding: 0 0;
    padding-top: 21px;
}
/deep/ .text-bold{
    font-weight: bold;
}
/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .v-input__append-inner{
    margin: 0 !important;
    margin: auto !important;
}

/deep/ .v-snack--vertical .v-snack__wrapper{
    flex-direction: row !important;
    flex-wrap: wrap !important;
    justify-content: space-between !important;
    margin-top: 84px;
    min-width: unset;
    padding: 0 20px;
}
/deep/ .v-snack__content{
    padding: 0px !important;
    margin-right: 30px;
}
/deep/ .v-snack--vertical .v-snack__wrapper .v-snack__action{
    margin: 0 !important;
    align-self: unset !important;
}
/deep/ .v-snack:not(.v-snack--has-background) .v-snack__wrapper{
    border: none !important;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
</style>
